//@actions
export const actions = {
  setAction(store: any, data: { key: string; value: any }) {
    store.commit("mutate", data);
  },
  changeResource(store: any, resource: string) {
    store.commit("updateResource", resource);
  },
  changeResourceId(store: any, resource_id: string) {
    store.commit("updateResourceId", resource_id);
  },
};
